import React from "react";
import { Recipient } from "./RecipientsCellRenderer.types";
import { getValidRecipients, truncateText } from "./RecipientsCellRenderer.utils";
import styles from "./RecipientsCellRenderer.module.css";

interface Props {
  value: Recipient[];
  setRecipientsModalData: (data: Recipient[]) => void;
  setShowRecipientsModal: (val: boolean) => void;
}

const RecipientsCellRenderer: React.FC<Props> = ({
  value,
  setRecipientsModalData,
  setShowRecipientsModal,
}) => {
  const recipients = value ?? [];

  if (recipients.length === 0) {
    return <span></span>;
  }

  const validRecipients = getValidRecipients(recipients);
  const firstValid = validRecipients[0];
  const totalValid = validRecipients.length;

  const handleClick = () => {
    setRecipientsModalData(recipients);
    setShowRecipientsModal(true);
  };

  if (!firstValid) {
    return (
      <span
        className={`download-links ${styles.emptyText}`}
        onClick={handleClick}
      >
        No recipients
      </span>
    );
  }

  return (
    <span
      className={`download-links ${styles.recipientsCell}`}
      onClick={handleClick}
      title={firstValid.RecipientEmail}
    >
      <span className={styles.emailText}>
        {firstValid.RecipientEmail}
      </span>

      {totalValid > 1 && (
        <span className={styles.moreCount}>
          (+{totalValid - 1})
        </span>
      )}
    </span>
  );
};

export default RecipientsCellRenderer;